import { useSuspenseQuery } from "@tanstack/react-query";
import { getRegistrationsByEvent } from "../openapi/api-client.ts";

export const useRegistrationsByEvent = (eventId: string) =>
  useSuspenseQuery({
    queryKey: ["registrations", eventId],
    queryFn: async () => {
      const response = await getRegistrationsByEvent(eventId);

      if (!response.data) {
        throw new Error(
          `error while fetching registrations: ${response.error.message}`,
        );
      }

      return response.data;
    },
  });
